module.exports = __webpack_public_path__ + "media/images/category/dummy/shoes04-1ed6fc2848543c598425f2390ee553f3.jpg";